"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _this = void 0;

/**
 * Semantic Version Number
 * @author 闲耘 <hotoo.cn@gmail.com>
 *
 * @usage
 *    const version = new Versioning("1.2.3")
 *    version > 1
 *    version.eq(1)
 */
// Semantic Versioning Delimiter.
var delimiter = '.';

var Version = function Version(version) {
  _this._version = String(version);
};

function compare(v1, v2, complete) {
  v1 = String(v1);
  v2 = String(v2);

  if (v1 === v2) {
    return 0;
  }

  var v1s = v1.split(delimiter);
  var v2s = v2.split(delimiter);
  var len = Math[complete ? 'max' : 'min'](v1s.length, v2s.length);

  for (var i = 0; i < len; i++) {
    v1s[i] = typeof v1s[i] === 'undefined' ? 0 : parseInt(v1s[i], 10);
    v2s[i] = typeof v2s[i] === 'undefined' ? 0 : parseInt(v2s[i], 10);

    if (v1s[i] > v2s[i]) {
      return 1;
    }

    if (v1s[i] < v2s[i]) {
      return -1;
    }
  }

  return 0;
}

Version.compare = function (v1, v2) {
  return compare(v1, v2, true);
};
/**
 * @param {String} v1.
 * @param {String} v2.
 * @return {Boolean} true if v1 equals v2.
 *
 *    Version.eq("6.1", "6"); // true.
 *    Version.eq("6.1.2", "6.1"); // true.
 */


Version.eq = function (v1, v2) {
  return compare(v1, v2, false) === 0;
};
/**
 * @param {String} v1.
 * @param {String} v2.
 * @return {Boolean} return true
 */


Version.gt = function (v1, v2) {
  return compare(v1, v2, true) > 0;
};

Version.gte = function (v1, v2) {
  return compare(v1, v2, true) >= 0;
};

Version.lt = function (v1, v2) {
  return compare(v1, v2, true) < 0;
};

Version.lte = function (v1, v2) {
  return compare(v1, v2, true) <= 0;
}; // eq相等   ne、neq不相等，   gt大于， lt小于 gte、ge大于等于   lte、le 小于等于   not非   mod求模   is [not] div by是否能被某数整除   is [not] even是否为偶数   is [not] even by $b即($a / $b) % 2 == 0   is [not] odd是否为奇   is not odd by $b即($a / $b) % 2 != 0 示例：


Version.prototype = {
  // new Version("6.1").eq(6); // true.
  // new Version("6.1.2").eq("6.1"); // true.
  eq: function eq(version) {
    return Version.eq(_this._version, version);
  },
  gt: function gt(version) {
    return Version.gt(_this._version, version);
  },
  gte: function gte(version) {
    return Version.gte(_this._version, version);
  },
  lt: function lt(version) {
    return Version.lt(_this._version, version);
  },
  lte: function lte(version) {
    return Version.lte(_this._version, version);
  },
  valueOf: function valueOf() {
    return parseFloat(_this._version.split(delimiter).slice(0, 2).join(delimiter), 10);
  },

  /**
   * XXX: ""+ver 调用的转型方法是 valueOf，而不是 toString，这个有点悲剧。
   * 只能使用 String(ver) 或 ver.toString() 方法。
   * @param {Number} precision, 返回的版本号精度。默认返回完整版本号。
   * @return {String}
   */
  toString: function toString(precision) {
    return typeof precision === 'undefined' ? _this._version : _this._version.split(delimiter).slice(0, precision).join(delimiter);
  }
};
var _default = Version;
exports.default = _default;